export default __webpack_public_path__ + "static/media/faviconStriebel.300c2071.ico";